import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueZoomer from 'vue-zoomer'
import Toaster from '@meforma/vue-toaster';
import Header from './components/Header'

const app = createApp(App)
app.use(router)
app.use(VueZoomer)
app.use(Toaster)
app.component("page-header", Header)
app.mount('#app')
